/**
 * One rule of a valid-when check, shared by the template-driven/reactive
 * `ValidWhenDirective` and the signal-forms `validWhen()` schema helper.
 * The rule passes when `expression` is truthy.
 */
export interface ValidWhenConfig {
  expression: unknown;
  /** Error key (directive) / error `kind` (signal forms). Defaults to `'validWhen'`. */
  errorProperty?: string;
  /** Error message. Defaults to `'Valid-when condition is not met!'`. */
  errorMessage?: string;
}

export const VALID_WHEN_DEFAULT_ERROR_PROPERTY = 'validWhen';
export const VALID_WHEN_DEFAULT_ERROR_MESSAGE =
  'Valid-when condition is not met!';
